<div class="flex flex-col">
    <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">{{ title() | transloco }}</p>
    @if (items().length) {
        @for (itemWithState of showAll() ? items() : items().slice(0, 3); track itemWithState.item) {
            <p
                class="!m-0"
                [ngClass]="{
                    'text-gray-300': fieldInterventionService.isNonApplicableForm(entity()!, itemWithState.item),
                }">
                {{ getLabel(itemWithState.item) }}
                @if (itemWithState.updated) {
                    <span class="text-xs font-normal italic text-custom-blue mx-1">{{ 'updated' | transloco }}</span>
                }

                @if (fieldInterventionService.isNonApplicableForm(entity()!, itemWithState.item)) {
                    <fa-icon
                        class="text-gray-300 cursor-pointer"
                        size="sm"
                        [icon]="['fas', 'circle-question']"
                        [matTooltip]="'formIsNotApplicable' | transloco" />
                }
            </p>
        }
        @if (items().length > 3) {
            <span
                class="text-outline cursor-pointer hover:underline pt-2"
                (click)="toggleList()">
                {{ (showAll() ? 'displayLess' : 'displayMore') | transloco }}
                {{ !showAll() ? `(${items().length - 3})` : '' }}
                <fa-icon
                    [icon]="['fas', 'chevron-down']"
                    [rotate]="showAll() ? 180 : undefined" />
            </span>
        }
    } @else {
        <p class="!m-0">-</p>
    }
</div>
